import HiveIcon from '@mui/icons-material/Hive';
import GrainIcon from '@mui/icons-material/Grain';
import HubIcon from '@mui/icons-material/Hub';
import ScienceIcon from '@mui/icons-material/Science';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LzCModule from '@lz-modules/Module';
import MeshModel from './Meshes/mesh.model';
import meshCrudConfig from './Meshes/config';

// Create the module and use the customized entities in it
const ParamsModule = new LzCModule({
    ident: 'params',
    name: 'Parameters',
    icon: <HiveIcon />,
    children: [
        { variation: 'Entity', ident: 'grains', icon: <GrainIcon /> },
        { variation: 'Entity', ident: 'meshes', icon: <HubIcon />, modelRef: MeshModel, crud: meshCrudConfig },
        { variation: 'Entity', ident: 'bonds', icon: <ScienceIcon /> },
        { variation: 'Entity', ident: 'other-ingredients', icon: <ReceiptLongIcon /> },
    ],
});

export default ParamsModule;
